<template>
    <div class="pop-content" v-if="couponStatus&&showTimeInfo">
        <div class="content">
            <div class="top-img" @click.stop="renew">
                <p class="title1">{{status===0?'宽带提速已到期':'宽带提速即将到期'}}</p>
                <div class="number">已为您准备 <span class="all-num">{{allNum}}元</span> 提速券</div>
                <div class="coupon-box" v-if="couponList.length">
                    <div class="coupon-item" v-for="(item,index) in couponList">
                        <div class="top-num">
                            <span>￥</span>
                            <span>{{item.formatAmount}}</span>
                        </div>
                        <div class="bottom-txt">{{item.desc}}</div>
                    </div>
                </div>
            </div>
            <div class="bottom-close" @click.stop="closePop"></div>
        </div>
    </div>
</template>

<script>
    import api from '../../../config/api';
    import renewCoupon from "../../../mixin/renewCoupon";
    export default {
        name: "CouponPop",
        props:['indexInfo'],
        mixins: [renewCoupon],
        data(){
          return {
              couponList:[],
              allNum: 0,
              couponStatus:true,
          }
        },
        created() {
            //document.body.style.overflow = 'hidden'
            this.gainCouponIndex()
        },
        beforeDestroy() {
            //document.body.style.overflow = 'auto'
        },
        methods:{
            //获取优惠券信息
            gainCouponIndex(){
                api.gainCouponIndex({
                    type:'renewal'
                }).then((res)=>{
                    if(res.code==0){
                        this.couponList = res.data;
                        this.allNum = this.couponList.reduce((preVal, currVal) => {
                            return preVal + currVal.formatAmount;
                        }, 0)
                        this.couponList.sort((a,b)=>{
                            return a.formatAmount - b.formatAmount
                        })
                    }
                })
            },
            //优惠券即将到期续约
            renew(){
                let renewCouponUrl = location.origin + "/jiasu?source=www-menu-speedup&refer=1"
                if (!this.$root.userInfoV3.id) {
                    sessionStorage.setItem('renewCouponUrl',renewCouponUrl)
                    this.$root.showLogin();
                } else {
                    api.renewCoupon().finally(()=>{
                        location.href = renewCouponUrl
                    })
                }
            },
            closePop() {
                this.couponStatus = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .pop-content {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(5, 4, 19, .8);
        z-index: 101;

        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            .top-img {
                margin: 0 auto 18px;
                width: 312px;
                height: 455px;
                background: url("../../../../images/expirePop/red-bg.png") no-repeat center;
                background-size: 100%;
                cursor: pointer;
                position: relative;
                .title1 {
                    width: 250px;
                    height: 42px;
                    text-align: center;
                    font-size: 30px;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 42px;
                    position: absolute;
                    top:155px;
                    left: 50%;
                    transform: translateX(-50%);
                }
                .number {
                    width: 250px;
                    position: absolute;
                    top:197px;
                    left: 50%;
                    transform: translateX(-50%);
                    height: 32px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 17px;
                    font-weight: 500;
                    color: #FFE98C;
                    .all-num {
                        width: 64px;
                        height: 23px;
                        background: #FFD243;
                        border-radius: 18px;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 600;
                        color: #E72511;
                        line-height: 23px;
                        margin: 0 5px;
                    }
                }
                .coupon-box {
                    position: absolute;
                    top: 275px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .coupon-item {
                        width: 80px;
                        height: 91px;
                        background: #FFF1F1;
                        border-radius: 4px;
                        margin-right: 10px;
                        padding: 10px 0 20px;
                        box-sizing: border-box;
                        &:last-child {
                            margin-right: 0;
                        }
                        .top-num {
                          display: flex;
                          justify-content: center;
                          align-items: flex-end;
                            span:nth-child(1) {
                                height: 30px;
                                font-size: 12px;
                                font-weight: bold;
                                color: #FF564D;
                                line-height: 30px;
                            }
                            span:nth-child(2) {
                                height: 45px;
                                font-size: 30px;
                                font-weight: 500;
                                color: #FF564D;
                                line-height: 45px;
                            }
                        }
                        .bottom-txt {
                            height: 18px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #FF564D;
                            line-height: 18px;
                            text-align: center;
                        }
                    }
                }
            }

            .bottom-close {
                margin: 18px auto 0;
                width: 37px;
                height: 37px;
                background: url("../../../../images/expirePop/close-tip.png") no-repeat center;
                background-size: 100%;
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/homePage/couponPop/CouponPop.vue